'use client';
import { Box } from '@mui/material';
import { useRef } from 'react';
import type { ProductCard as ProductCardType } from '@repo/supergraph/roundup/base/types';
import { dynamicWithRetry } from '../../../../DynamicWithRetry';
import { DesktopFilters } from '../../../components/OffersFilter/DesktopFilterBar';
import { MobileFilters } from '../../../components/OffersFilter/MobileFilters';
import { OffersFilterStoreProvider } from '../../../components/OffersFilter/store';
import { OfferList } from './components/OffersList';

const CompareStickyBar = dynamicWithRetry<Record<string, never>>(
  () => import('../components/CompareStickyBar').then(mod => ({ default: mod.CompareStickyBar })),
  { componentName: 'CompareStickyBar' },
);

const ComparisonTable = dynamicWithRetry<Record<string, never>>(
  () => import('../components/ComparisonTable').then(mod => ({ default: mod.ComparisonTable })),
  { componentName: 'ComparisonTable' },
);

type Props = {
  offers: ProductCardType[];
  pageUrl: string;
  isCompareEnabled?: boolean;
};

export const FilterSections = ({ offers, pageUrl, isCompareEnabled = false }: Props) => {
  const offerListRef = useRef<HTMLDivElement>(null);
  const slug = 'cd-rates';
  const analyticsProps = {
    actionSection: 'banking_cd_filter',
    pageIdentifier: 'cd',
  };
  return (
    <OffersFilterStoreProvider offers={offers} slug={slug}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: { xs: '100%', md: '82%' },
          marginX: 'auto',
        }}
        data-testid="filters-section"
        component="section"
      >
        <MobileFilters slug={slug} analyticsProps={analyticsProps} />
        <DesktopFilters mainSectionRef={offerListRef} slug={slug} analyticsProps={analyticsProps} />
        <OfferList
          pageUrl={pageUrl}
          offerListRef={offerListRef}
          analyticsProps={analyticsProps}
          isCompareEnabled={isCompareEnabled}
        />
      </Box>
      {isCompareEnabled && (
        <>
          <CompareStickyBar />
          <ComparisonTable />
        </>
      )}
    </OffersFilterStoreProvider>
  );
};
